<template>
  <header>
    <p>フッター</p>
  </header>
</template>

<script>
export default {
  data() {},
}
</script>
